// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__24EiN","dark":"PageHeader_dark__3jenO","light":"PageHeader_light__3MkfT"};